import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSnackbarSuccess, MandatoryStar } from "../../Utils/helper";
import {
    BillingAdjustmentAction,
  GetInsurerPayoutCountsNetwork,
  GetTotalAppointmentAction,
} from "../../redux/actions/InsBillAction";

export const AdjustmentAmount = ({
  searchFilter,
  setAdjustAmtIsOpen,
  providerDetail,
  setProviderDetail,
  openModel,
  setOpenModel
}) => {
  const ref = useRef();
  const [payload, setPayload] = useState({
    adjustmentType: providerDetail[0]?.appointmentId,
    adjustmentAmount:providerDetail[0]?.adjustAmount,
    remarks: "",
  });
  const dispatch = useDispatch();
  const insBillReducer = useSelector((state) => state?.InsBillingPayout?.insRemarks);

  useEffect(()=>{
    const rem = insBillReducer?.filter((ele)=>{
      if(ele?.appointmentId === providerDetail[0]?.appointmentId && ele?.remarksType === "Adjustment" ){
        return ele
      }
    })
    setPayload({
      adjustmentType: providerDetail[0]?.adjustmentType,
      adjustmentAmount:providerDetail[0]?.adjustAmount,
      remarks:rem[0]?.remarks,
    })
  },[providerDetail])

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    if (event.target.checkValidity()) {
      if(payload?.adjustmentType === "minus" && +payload?.adjustmentAmount > +providerDetail[0]?.insurerSum){
        getSnackbarSuccess("warning","Adjustment Amount should be less than or equal to Insurer Amount",dispatch)
      } else {
        const res = await dispatch(
          BillingAdjustmentAction({
            appointmentId: providerDetail[0]?.appointmentId,
            clientId: providerDetail[0]?.clientId,
            ...payload
          })
        );
        if (res) {
          getSnackbarSuccess("success", res?.data?.message, dispatch);
          setTimeout(()=>{
            dispatch(
              GetTotalAppointmentAction({
                ...searchFilter,
                page: 1,
                rows: 10,
                IsPayoutStatus: true,
              })
            );
            dispatch(GetInsurerPayoutCountsNetwork({ ...searchFilter, page: 1 }));
          },2000)
          handleClose();
        }
      }
      
    }
  };

  const handleClose = () => {
    setOpenModel({...openModel,adjustAmount :false})
    setProviderDetail([]);
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black ">Adjustment</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose()}
        ></button>
      </div>

      <form
        ref={ref}
        className="form-admin"
        // style={{ overflowX: "hidden" }}
        onSubmit={handleSubmit}
        noValidate
      >
        <div className="modal-body">
          <div className="row ">
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">Case Number</label>
              <input
                name="caseNo"
                type="text"
                disabled
                style={{backgroundColor:"#EEEEEE"}}
                value={providerDetail[0]?.caseNo}
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
              />
            </div>
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">Insurer Amount</label>
              <input
                name="caseNo"
                type="text"
                disabled
                style={{backgroundColor:"#EEEEEE"}}
                value={providerDetail[0]?.insurerSum}
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                
              />
            </div>
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">Adjustment</label><MandatoryStar />
              <select
                name="BusinessType"
                className="form-select"
                style={{ height: "40px" }}
                required
                value={payload?.adjustmentType}
                onChange={(e) => {
                setPayload({...payload,adjustmentType:e.target.value})
                }}
              >
                <option value="">Select Type</option>
                <option value="plus">Plus</option>
                <option value="minus">Minus</option>
              </select>
            </div>
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">
                Adjustment Amount
                <MandatoryStar />
              </label>
              <input
                name="providerAmount"
                type="number"
                placeholder="Enter Here..."
                value={payload?.adjustmentAmount}
                onKeyPress={(e) => {
                  const value = e.target.value;
                  const allowedChars = /^[0-9\b.]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }

                  // Check if the input already contains a decimal point
                  if (e.key === "." && value.includes(".")) {
                    e.preventDefault();
                  }

                  // Check if the input is going to exceed two decimal places
                  if (
                    value.includes(".") &&
                    value.split(".")[1].length >= 2 &&
                    e.key !== "Backspace"
                  ) {
                    e.preventDefault();
                  }
                }}
                min={1}
                className="form-control form-select-admin inputbgavanish"
                required
                onChange={(e) => {
                    setPayload({...payload,adjustmentAmount:e.target.value})
                }}
              />
            </div>
            <div className="col-lg-12 col-md-12 mt-2">
              <label className="col-form-label">
                Remarks
                <MandatoryStar />
              </label>
              <textarea
                className="form-control form-select-admin inputbgavanish"
                rows="5"
                cols="33"
                style={{border:"1px solid #eeeeee",borderRadius:"5px"}}
                
                value={payload?.remarks}
                onKeyPress={(e) => {
                  const re = /^[a-zA-Z\s]*$/;
                  if (e.target.value.trim() === "" && e.key === " ") {
                    e.preventDefault();
                    return;
                  }
                }}
                required
                onChange={(e) => setPayload({...payload,remarks:e.target.value})}
              ></textarea>
            </div>
          </div>
        </div>

        <div className="modal-footer modal-footer-admin  bottom-0  mt-4">
          <div className="d-flex justify-content-end flex-wrap gap-10">
            <button
              onClick={() => handleClose()}
              type="btn"
              className="savedetails"
            >
              Cancel
            </button>
            <button type="submit" className="savedetails">
              {"Update"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};
